module.exports = __webpack_public_path__ + "img/banner-1.3e6b9a72.jpg";